"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import _ from "underscore";
import Account from "../../api/account";
import ToDashboardWithFilters from "../ui/to_dashboard_with_filters";
import Api from "../../api/api";
import { v4 as uuid } from "@lukeed/uuid/secure";
import Auth from "../../util/auth";
import {
  CARRIER_INVOICE_MODEL_OBJECT_TYPE,
  LOAD_SHIPMENT_MODEL_OBJECT_TYPE
} from "../../api/exception_events";
import { Button, ButtonSize, ButtonVariant } from "../ui/v3/button";
export const INVOICE_CONTEXT = "invoice";
export const DOCUMENTS_CONTEXT = "documents";
export const BILLING_TYPE = "billing";
export const PAYMENT_TYPE = "payment";
const LOAD_NOT_FOUND_MESSAGE = "Load not found.";
const NO_NEED_TO_PROCESS_MESSAGE = "Does not need to be processed.";
const OTHER_MESSAGE = "Other";
function renderOption(message) {
  return /* @__PURE__ */ jsx("option", { value: message, children: message });
}
function savingButton() {
  return /* @__PURE__ */ jsx("button", { disabled: true, children: "Saving..." });
}
function paymentExceptionTypeLabel() {
  return "Payment";
}
function showExceptionTypeArea(props) {
  var _a;
  return (_a = props.auditBillingEnabled) != null ? _a : Account.auditBillingEnabled();
}
function possibleUserInstructions(props) {
  if (props.context === DOCUMENTS_CONTEXT) {
    return /* @__PURE__ */ jsx("div", { className: "new-exception__user-instructions", children: "If the problem is related to a missing document or amount mismatch, create the exception on the confirm and submit screen." });
  }
}
function buildTypes(state) {
  const types = [];
  if (state.billingSelected) {
    types.push(BILLING_TYPE);
  }
  if (state.paymentSelected) {
    types.push(PAYMENT_TYPE);
  }
  return types;
}
function exceptionMessage(state) {
  var autofilledExceptionMessage = state.autofilledExceptionMessage;
  var customExceptionMessage = state.customExceptionMessage;
  return autofilledExceptionMessage === "Other" ? customExceptionMessage : autofilledExceptionMessage;
}
function isSaveDisabled(props, state) {
  const noExceptionTypeSelected = props.context == INVOICE_CONTEXT && showExceptionTypeArea(props) && !state.paymentSelected && !state.billingSelected;
  return state.saving || noExceptionTypeSelected;
}
function billingExceptionTypeLabel(props) {
  if (props.modelObjectType === CARRIER_INVOICE_MODEL_OBJECT_TYPE) {
    return "Billing (all customers)";
  } else {
    return "Billing (this customer)";
  }
}
function exceptionCreationComplete(props, sendMessage, hasMore) {
  var _a, _b;
  if (sendMessage) {
    (_a = props.startSendEmail) == null ? void 0 : _a.call(props);
  }
  if (!_.isUndefined(hasMore)) {
    if (!sendMessage && !hasMore) {
      ToDashboardWithFilters(props.location);
    } else if (!sendMessage && hasMore) {
      (_b = props.documentsExceptionAddedCallback) == null ? void 0 : _b.call(props);
    }
  }
}
export default class extends React.Component {
  constructor(props, context) {
    super(props, context);
    __publicField(this, "documentsMessages", () => {
      const messages = [LOAD_NOT_FOUND_MESSAGE];
      if (!Auth.getCurrentUser().managed_indexer) {
        messages.push(NO_NEED_TO_PROCESS_MESSAGE);
      }
      messages.push(OTHER_MESSAGE);
      return messages;
    });
    __publicField(this, "documentsOptions", () => {
      return this.documentsMessages().map(renderOption);
    });
    __publicField(this, "invoiceMessages", () => {
      const messages = Api.Account.currentSettings().custom_invoice_exception_messages || [];
      const sortedMessages = _.sortBy(messages, (message) => {
        return message.toLowerCase();
      });
      sortedMessages.push(OTHER_MESSAGE);
      return [...new Set(sortedMessages)];
    });
    __publicField(this, "invoiceOptions", () => {
      return this.invoiceMessages().map(renderOption);
    });
    __publicField(this, "initialExceptionMessage", () => {
      if (this.props.context === INVOICE_CONTEXT) {
        return OTHER_MESSAGE;
      }
      return this.documentsMessages()[0];
    });
    __publicField(this, "newException", () => {
      return /* @__PURE__ */ jsxs("div", { children: [
        possibleUserInstructions(this.props),
        this.descriptionDropdown(),
        this.possibleTextArea(),
        this.possibleCreateExceptionButton()
      ] });
    });
    __publicField(this, "newExceptionV3Reskin", () => {
      return /* @__PURE__ */ jsxs(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            padding: "16px",
            background: "var(--color-grayscale-100)",
            border: "1px solid var(--color-border-default)",
            borderRadius: "8px"
          },
          children: [
            this.possibleExceptionTypeAreaV3Reskin(),
            this.descriptionDropdownV3Reskin(),
            this.possibleTextAreaV3Reskin(),
            /* @__PURE__ */ jsx("div", { style: { alignSelf: "flex-end" }, children: this.possibleCreateExceptionButtonV3Reskin() })
          ]
        }
      );
    });
    __publicField(this, "descriptionOptions", () => {
      if (this.props.context === INVOICE_CONTEXT) {
        return this.invoiceOptions();
      }
      return this.documentsOptions();
    });
    __publicField(this, "descriptionDropdown", () => {
      return /* @__PURE__ */ jsxs("div", { className: "new-exception__description-dropdown", children: [
        /* @__PURE__ */ jsx("label", { children: "Exception Description" }),
        /* @__PURE__ */ jsx(
          "select",
          {
            value: this.state.autofilledExceptionMessage,
            onChange: (e) => this.setState({
              autofilledExceptionMessage: e.target.value
            }),
            children: this.descriptionOptions()
          }
        )
      ] });
    });
    __publicField(this, "descriptionDropdownV3Reskin", () => {
      return /* @__PURE__ */ jsxs("label", { className: "v3__input-label", children: [
        /* @__PURE__ */ jsx("div", { className: "v3__input-label-text", children: "Exception type" }),
        /* @__PURE__ */ jsx("div", { className: "v3__input-wrapper", children: /* @__PURE__ */ jsx(
          "select",
          {
            className: "v3__input v3__simple-select v3__simple-select--size-medium",
            value: this.state.autofilledExceptionMessage,
            onChange: (e) => this.setState({
              autofilledExceptionMessage: e.target.value
            }),
            children: this.descriptionOptions()
          }
        ) })
      ] });
    });
    __publicField(this, "possibleTextArea", () => {
      if (this.state.autofilledExceptionMessage === "Other") {
        return /* @__PURE__ */ jsxs("div", { className: "new-exception__text-area", children: [
          /* @__PURE__ */ jsx("label", { children: "Description" }),
          /* @__PURE__ */ jsx(
            "textarea",
            {
              value: this.state.customExceptionMessage || "",
              onChange: (e) => this.setState({
                customExceptionMessage: e.target.value
              }),
              rows: 4
            }
          )
        ] });
      }
    });
    __publicField(this, "possibleTextAreaV3Reskin", () => {
      if (this.state.autofilledExceptionMessage === "Other") {
        return /* @__PURE__ */ jsxs("label", { className: "v3__input-label", children: [
          /* @__PURE__ */ jsx("div", { className: "v3__input-label-text", children: "Description" }),
          /* @__PURE__ */ jsx("div", { className: "v3__input-wrapper", children: /* @__PURE__ */ jsx(
            "textarea",
            {
              className: "v3__input",
              placeholder: "Describe the exception",
              value: this.state.customExceptionMessage || "",
              onChange: (e) => this.setState({
                customExceptionMessage: e.target.value
              }),
              style: { height: "126px" }
            }
          ) })
        ] });
      }
    });
    __publicField(this, "cancelException", () => {
      this.setState({ customExceptionMessage: "" });
      this.props.onCancel();
    });
    __publicField(this, "createExceptionAndSend", () => {
      if (this.props.context === INVOICE_CONTEXT) {
        this.createException(true, buildTypes(this.state));
      } else {
        this.createException(true);
      }
    });
    __publicField(this, "createExceptionWithoutSending", () => {
      if (this.props.context === INVOICE_CONTEXT) {
        this.createException(false, buildTypes(this.state));
      } else {
        this.createException(false);
      }
    });
    __publicField(this, "createException", (sendMessage, types) => {
      var hasMore = this.props.hasMore;
      var create = () => {
        const message = exceptionMessage(this.state);
        const ignored = this.ignored();
        this.setState({ saving: true });
        this.props.exceptionCreator(message, ignored, types).then(() => {
          exceptionCreationComplete(this.props, sendMessage, hasMore);
        });
      };
      if (this.ignored()) {
        if (confirm("Are you sure you would like to ignore this group?")) {
          create();
        }
      } else {
        create();
      }
    });
    __publicField(this, "ignored", () => {
      return this.state.autofilledExceptionMessage === NO_NEED_TO_PROCESS_MESSAGE;
    });
    __publicField(this, "possibleCreateExceptionButton", () => {
      if (this.props.hasMore) {
        var completionContext = "and go to next group";
      } else {
        var completionContext = "and return to dashboard";
      }
      if (this.state.saving) {
        return /* @__PURE__ */ jsx("div", { className: "new-exception__possible-create-exception-button", children: savingButton() });
      } else {
        if (this.props.startSendEmail) {
          return /* @__PURE__ */ jsxs("div", { className: "new-exception__possible-create-exception-button", children: [
            /* @__PURE__ */ jsx(
              "button",
              {
                className: "rules__add-exception-button",
                disabled: isSaveDisabled(this.props, this.state),
                onClick: this.createExceptionAndSend,
                children: "Save & Send Message"
              }
            ),
            /* @__PURE__ */ jsx(
              "button",
              {
                className: "button--secondary",
                disabled: isSaveDisabled(this.props, this.state),
                onClick: this.createExceptionWithoutSending,
                children: "Save Without Sending"
              }
            ),
            /* @__PURE__ */ jsxs("span", { className: "new-exception__completion-context", children: [
              " ",
              completionContext,
              " "
            ] }),
            /* @__PURE__ */ jsx("br", { className: "show_for_non_reskin" }),
            /* @__PURE__ */ jsx("span", { className: "new-exception__completion-context-or", children: "or " }),
            /* @__PURE__ */ jsx(
              "a",
              {
                className: "new-exception__cancel-link",
                onClick: this.cancelException,
                children: "cancel"
              }
            )
          ] });
        } else {
          return /* @__PURE__ */ jsxs("div", { className: "row", children: [
            /* @__PURE__ */ jsxs("div", { className: "large-4 column", children: [
              /* @__PURE__ */ jsx(
                "button",
                {
                  className: "rules__add-exception-button",
                  disabled: isSaveDisabled(this.props, this.state),
                  onClick: this.createExceptionWithoutSending,
                  children: "Save Exception"
                }
              ),
              /* @__PURE__ */ jsx("a", { onClick: this.cancelException, children: "cancel" })
            ] }),
            /* @__PURE__ */ jsx("div", { className: "large-6 column", children: this.possibleExceptionTypeArea() })
          ] });
        }
      }
    });
    __publicField(this, "possibleCreateExceptionButtonV3Reskin", () => {
      if (this.state.saving) {
        return /* @__PURE__ */ jsx(
          Button,
          {
            size: ButtonSize.Medium,
            variant: ButtonVariant.Outlined,
            disabled: true,
            children: "Saving..."
          }
        );
      } else {
        return /* @__PURE__ */ jsxs("div", { style: { display: "flex", gap: "16px", alignItems: "center" }, children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              size: ButtonSize.Medium,
              variant: ButtonVariant.Text,
              onClick: this.cancelException,
              style: { padding: "0" },
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ jsx(
            Button,
            {
              size: ButtonSize.Medium,
              variant: ButtonVariant.Outlined,
              disabled: isSaveDisabled(this.props, this.state),
              onClick: this.createExceptionWithoutSending,
              children: "Save"
            }
          )
        ] });
      }
    });
    __publicField(this, "possibleExceptionTypeArea", () => {
      if (showExceptionTypeArea(this.props)) {
        const idPrefix = `exception-type-${uuid()}`;
        const billingId = `${idPrefix}-billing`;
        const paymentId = `${idPrefix}-payment`;
        return /* @__PURE__ */ jsxs("div", { className: "rules__exception-type-area-container", children: [
          /* @__PURE__ */ jsx("span", { className: "rules__exception-type-area-label bold", children: "Exception type:" }),
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "checkbox",
              id: billingId,
              value: billingId,
              checked: this.state.billingSelected,
              onChange: this.buildToggleExceptionTypeHandler(BILLING_TYPE)
            }
          ),
          /* @__PURE__ */ jsx("label", { htmlFor: billingId, children: billingExceptionTypeLabel(this.props) }),
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "checkbox",
              id: paymentId,
              value: paymentId,
              checked: this.state.paymentSelected,
              onChange: this.buildToggleExceptionTypeHandler(PAYMENT_TYPE)
            }
          ),
          /* @__PURE__ */ jsx("label", { htmlFor: paymentId, children: paymentExceptionTypeLabel() })
        ] });
      }
    });
    __publicField(this, "possibleExceptionTypeAreaV3Reskin", () => {
      if (showExceptionTypeArea(this.props)) {
        const idPrefix = `exception-type-${uuid()}`;
        const billingId = `${idPrefix}-billing`;
        const paymentId = `${idPrefix}-payment`;
        return /* @__PURE__ */ jsxs("div", { className: "v3__input-label", children: [
          /* @__PURE__ */ jsx("div", { className: "v3__input-label-text", children: "Exception" }),
          /* @__PURE__ */ jsx("div", { className: "v3__input-wrapper", children: /* @__PURE__ */ jsxs("div", { style: { display: "flex", gap: "16px" }, children: [
            /* @__PURE__ */ jsxs(
              "div",
              {
                style: { display: "flex", gap: "8px", alignItems: "center" },
                children: [
                  /* @__PURE__ */ jsx(
                    "input",
                    {
                      type: "checkbox",
                      id: billingId,
                      value: billingId,
                      checked: this.state.billingSelected,
                      onChange: this.buildToggleExceptionTypeHandler(BILLING_TYPE),
                      style: { margin: "0" }
                    }
                  ),
                  /* @__PURE__ */ jsx("label", { htmlFor: billingId, style: { margin: "0" }, children: billingExceptionTypeLabel(this.props) })
                ]
              }
            ),
            /* @__PURE__ */ jsxs(
              "div",
              {
                style: { display: "flex", gap: "8px", alignItems: "center" },
                children: [
                  /* @__PURE__ */ jsx(
                    "input",
                    {
                      type: "checkbox",
                      id: paymentId,
                      value: paymentId,
                      checked: this.state.paymentSelected,
                      onChange: this.buildToggleExceptionTypeHandler(PAYMENT_TYPE),
                      style: { margin: "0" }
                    }
                  ),
                  /* @__PURE__ */ jsx("label", { htmlFor: paymentId, style: { margin: "0" }, children: paymentExceptionTypeLabel() })
                ]
              }
            )
          ] }) })
        ] });
      }
    });
    __publicField(this, "buildToggleExceptionTypeHandler", (exceptionType) => {
      return () => {
        if (exceptionType === BILLING_TYPE) {
          this.setState((prevState) => ({
            billingSelected: !prevState.billingSelected
          }));
        } else {
          this.setState((prevState) => ({
            paymentSelected: !prevState.paymentSelected
          }));
        }
      };
    });
    const isPaymentSelectedByDefault = props.modelObjectType === CARRIER_INVOICE_MODEL_OBJECT_TYPE;
    const isBillingSelectedByDefault = props.modelObjectType === LOAD_SHIPMENT_MODEL_OBJECT_TYPE;
    this.state = {
      autofilledExceptionMessage: this.initialExceptionMessage(),
      billingSelected: isBillingSelectedByDefault,
      paymentSelected: isPaymentSelectedByDefault
    };
  }
  render() {
    if (this.props.v3ReskinEnabled) {
      return this.newExceptionV3Reskin();
    } else {
      return /* @__PURE__ */ jsx("div", { className: "rules__new-exception", "data-component": "NewException", children: this.newException() });
    }
  }
}
